export const tooltips: { [key: string]: string} = {
    typePensionFund: `
    <span>
        The providers only offer lifetime annuities for personal pension schemes. If you’re unsure which
        pension type you have please select 'Personal Pension but not sure which scheme'.
        <br><br>
        Final Salary Schemes (known as Defined Benefit Schemes) are not accepted by Annuity Ready.
    </span>`,
    currentProvider: `<span>
        Please refer to your most recent annual pension fund statement if you are unsure of 
        your current pension fund provider.
        <br><br>
        This should be the name of the pension provider and not the name of the broker/adviser.
        </span>`,
    accountNumber: "An eight-digit number found on your bank card, bank statements, online account or cheque book.",
    sortCode: "A six-digit number found on your bank card, bank statements, online account or cheque book.",
    schemeName: `Please refer to your current pension fund provider documents or ask your current 
        pension provider if you are unsure.`,
};
